export default __webpack_public_path__ + "static/media/1017.bd68e26d.svg";